// extracted by mini-css-extract-plugin
export default {"img_wrapper":"imgContainer_img_wrapper__QrMjB","img":"imgContainer_img__-zhoG"};